// Copyright 2018 Sorama B.V.

export class LimitToValueConverter {
    toView(array: unknown[], count: number) {
        return array.slice(0, count);
    }
}
